"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionTabGrasshopper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const styled_components_1 = __importStar(require("styled-components"));
const MultiSelectionTabContentGrasshopper_1 = require("../MultiSelectionTabContentGrasshopper");
const ViewControls_1 = require("../ViewControls");
function MultiSelectionTabGrasshopper({ selectedItemViewControl, setSelectedViewControl, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const infoboxControls = (0, hooks_1.useInfoBoxControlsState)();
    const { items } = (0, hooks_1.useMultiSelectState)();
    const bridge = (0, bridge_1.useBridge)();
    const onViewControlClick = (type) => {
        switch (type) {
            case ViewControls_1.ViewControlsType.Hide:
                bridge === null || bridge === void 0 ? void 0 : bridge.hideAction();
                break;
            case ViewControls_1.ViewControlsType.Fade:
                bridge === null || bridge === void 0 ? void 0 : bridge.fadeAction();
                break;
            case ViewControls_1.ViewControlsType.HideOthers:
                bridge === null || bridge === void 0 ? void 0 : bridge.hideOthersAction();
                break;
            case ViewControls_1.ViewControlsType.FadeOthers:
                bridge === null || bridge === void 0 ? void 0 : bridge.fadeOthersAction();
                break;
        }
    };
    const onClickControls = (type) => {
        return () => {
            onViewControlClick(type);
            if (type === selectedItemViewControl) {
                setSelectedViewControl(undefined);
            }
            else {
                setSelectedViewControl(type);
            }
        };
    };
    const multiSelectionTabsButtons = [
        {
            onClick: onClickControls(ViewControls_1.ViewControlsType.Hide),
            label: t(i18n_1.Strings.infoBox.menu.hidden).toUpperCase(),
            isSelected: infoboxControls.hidden === 1,
        },
        {
            onClick: onClickControls(ViewControls_1.ViewControlsType.HideOthers),
            label: t(i18n_1.Strings.infoBox.menu.hidingOthers).toUpperCase(),
            isSelected: infoboxControls.hidingOthers === 1,
        },
        {
            onClick: onClickControls(ViewControls_1.ViewControlsType.Fade),
            label: t(i18n_1.Strings.infoBox.menu.faded).toUpperCase(),
            isSelected: infoboxControls.faded === 1,
        },
        {
            onClick: onClickControls(ViewControls_1.ViewControlsType.FadeOthers),
            label: t(i18n_1.Strings.infoBox.menu.fadingOthers).toUpperCase(),
            isSelected: infoboxControls.fadingOthers === 1,
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'MultiSelectionTabGrasshopper_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { "data-e2e": 'MultiSelectionTabGrasshopper_Header', children: [(0, jsx_runtime_1.jsx)(PrimaryName, { "data-e2e": 'MultiSelectionTabGrasshopper_PrimaryName', children: t(i18n_1.Strings.infoBox.menu.multiSelect) }), ' ', (0, jsx_runtime_1.jsx)(CloseForGrasshopperStyled, { onClick: () => {
                            bridge === null || bridge === void 0 ? void 0 : bridge.enableMultipleSelection();
                        }, "data-e2e": 'MultiSelectionTabGrasshopper_CloseForGrasshopperStyled' })] }), (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'MultiSelectionTabGrasshopper_ButtonsContainer', children: multiSelectionTabsButtons.map(({ onClick, isSelected, label }) => ((0, jsx_runtime_1.jsx)(StyledButton, { onClick: onClick, isSelected: isSelected, disabled: infoboxControls.hidingOthers === -1, "data-e2e": 'MultiSelectionTabGrasshopper_StyledButton', children: label }, label))) }), (0, jsx_runtime_1.jsx)(MultiSelectionTabContentGrasshopper_1.MultiSelectionTabContentGrasshopper, { "data-e2e": 'MultiSelectionTabGrasshopper_MultiSelectionTabContentGrasshopper', children: items })] }));
}
exports.MultiSelectionTabGrasshopper = MultiSelectionTabGrasshopper;
const Header = styled_components_1.default.div `
  padding: 16px;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
`;
const CloseForGrasshopperStyled = (0, styled_components_1.default)(ui_1.CloseForGrasshopper) `
  position: absolute;
  border: 0;
  right: 1px;
`;
const PrimaryName = styled_components_1.default.div `
  color: ${({ theme }) => theme.white};
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  margin: 0;
`;
const ButtonsContainer = styled_components_1.default.div `
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  pointer-events: auto;
`;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  justify-content: left;
  padding: 8px 0px 8px 0px;
  ${({ isSelected, disabled }) => isSelected &&
    !disabled &&
    (0, styled_components_1.css) `
      background-color: inherit;
    `}
  ${({ isSelected, disabled }) => !isSelected &&
    !disabled &&
    (0, styled_components_1.css) `
      &:hover {
        background-color: inherit;
      }
    `}
`;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  overflow: hidden;
  width: 200px;
  height: 674px;
`;
